import { owcTheme } from 'core/theme/theme.config';
import { ModalDialog } from 'commons/components';
import styled from 'styled-components';

export const EapSettingsImportLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    owc-typography[variant='body1'] {
        color: ${owcTheme['one-color-gray-600']};
    }
`;

export const EapSettingsImportFieldRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 240px;
    gap: 16px;
    align-items: center;
`;

export const EapSettingsImportFileUploadedLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const EapSettingsImportConfirmationModalContent = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
`;

export const EapSettingsImportModal = styled(ModalDialog)`
    owc-card {
        width: min(760px, calc(100vw - 2rem));
        max-width: min(760px, calc(100vw - 2rem));
    }
`;
